import { render } from "./typeDictionary_c.vue?vue&type=template&id=6837a4af"
import script from "./typeDictionary_c.vue?vue&type=script&lang=js"
export * from "./typeDictionary_c.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__